<template lang="html">
  <div class="row col-xs no-margin no-padding middle-xs">
    <div class="flex middle-xs filter-bar">
      <span class="f4 fw4">From </span>
      <div class="flex items-center">
        <flat-pickr
          class="filter-date-picker clickable"
          v-model="min_date"
          :config="config"
          placeholder="Select a date"
          style="color: #000"
        ></flat-pickr>
        <a class="input-button clickable" data-toggle>
          <i
            class="fa fa-caret-down"
            style="font-size: 16px; color: #000; margin-right: 20px"
          />
        </a>
      </div>
      <span class="f4 fw4"> to </span>
      <div class="flex items-center">
        <flat-pickr
          class="filter-date-picker clickable"
          v-model="max_date"
          :config="config"
          placeholder="Select a date"
          style="color: #000"
        ></flat-pickr>
        <a class="input-button clickable" data-toggle>
          <i class="fa fa-caret-down" style="font-size: 16px; color: #000" />
        </a>
      </div>
      <div
        class="ml-2.5 flex items-center border border-solid border-gray-200 bg-gray-100 rounded text-sm"
      >
        <div class="flex justify-center items-center px-2.5">
          <i class="fa-solid text-center fa-at"></i>
        </div>
        <input
          class="w-100 outline-none border-none pr-4 pl-1 py-2"
          v-model="email_domain"
          placeholder="Search by email suffix"
        />
      </div>
      <pl-button
        class="pl-primary search-button"
        style="margin: 2px 10px"
        @click.native="searchAnalytics"
      >
        SEARCH
      </pl-button>
    </div>
    <div class="col-xs-12 no-padding last-updated">
      (last updated {{ latest_update }})
    </div>
    <div v-if="message_error" class="col-xs-12 no-padding">
      <span class="red">
        Please check selected dates. End date must be greater than begin date
        and date interval must be less than two years.</span
      >
    </div>
  </div>
</template>
<script>
  import flatPickr from 'vue-flatpickr-component';
  import Multiselect from 'vue-multiselect';
  import adminServices from 'services/admin/adminServices';
  import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';

  export default {
    components: {
      flatPickr,
      Multiselect,
    },
    data() {
      return {
        min_date: null,
        max_date: null,
        config: {
          wrap: true,
          plugins: [
            new monthSelectPlugin({
              shorthand: true,
              dateFormat: 'F Y',
              altFormat: 'F  Y',
            }),
          ],
        },
        message_error: '',
        latest_update: '',
        email_domain: '',
      };
    },
    methods: {
      searchAnalytics() {
        this.message_error = false;

        const newMinDate = '01 ' + this.min_date;

        const newMaxDate = '01 ' + this.max_date;

        const minDateAux = new Date(newMinDate);
        const minDateString =
          minDateAux.getFullYear() +
          '/' +
          (minDateAux.getMonth() + 1) +
          '/' +
          minDateAux.getDate();
        const minDate = new Date(minDateString);

        const maxDateAux = new Date(newMaxDate);
        const year = maxDateAux.getFullYear();
        const month = maxDateAux.getMonth() + 1;
        const maxDateString =
          year + '/' + month + '/' + maxDateAux.getDate() + ' 23:59:59';
        const maxDate = new Date(maxDateString);

        const differenceInYears = (maxDate - minDate) / 31556952000;

        if (minDate < maxDate && differenceInYears < 2.0) {
          this.$emit('date_filter', {
            begin_date: minDateString,
            end_date: maxDateString,
            email_domain: this.email_domain,
          });
        } else {
          this.message_error = true;
        }
      },
      getLatestDateUpdate() {
        adminServices
          .getLatestDateUpdate()
          .then(({ data: { end_date: end_date_string } }) => {
            const end_date = new Date(end_date_string);

            const day = end_date.toLocaleDateString();

            const time = end_date.toLocaleTimeString();

            this.latest_update = `${day} at ${time}`;
          });
      },
    },
    mounted() {
      const current_month = new Date().getMonth() + 1;
      if (current_month >= 8) {
        this.min_date = 'August ' + new Date().getFullYear();
        this.max_date = 'July ' + (new Date().getFullYear() + 1);
      } else {
        this.min_date = 'August ' + (new Date().getFullYear() - 1);
        this.max_date = 'July ' + new Date().getFullYear();
      }
      this.searchAnalytics();
      this.getLatestDateUpdate();
    },
  };
</script>
<style lang="stylus" scoped>
  .filter-bar
    font-size: 16px
  .flatpickr-input
    text-align: center
    font-weight: 600
    text-decoration: underline
    max-width: 145px
  .search-button
    width: 150px
    margin-left: 20px
  .trial-teacher-span
    color: #797979
    &:hover
      cursor: pointer
      text-decoration: underline
  .last-updated
    line-height: 13px
    font-size: 11px
    font-style: italic
</style>
<style src="flatpickr/dist/plugins/monthSelect/style.css"></style>
<style lang="scss">
  .filter-date-picker + input {
    text-align: center;
    font-weight: 600;
    text-decoration: underline;
    max-width: 175px;
  }
</style>



// WEBPACK FOOTER //
// adminViewAnalyticsFiltersBar.vue?94b04286